import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import CheckIcon from '@mui/icons-material/Check';
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
} from '@mui/lab';
import {
  TIMELINE_FINISHED_DOT_CLASS_NAME,
  TIMELINE_ACTIVE_DOT_CLASS_NAME,
  TIMELINE_PENDING_DOT_CLASS_NAME,
  TIMELINE_CLASS_NAME,
  TIMELINE_LABEL_CLASS_NAME,
  TIMELINE_CAPTION_CLASS_NAME,
} from '../../../theme/constants/timeline';

const STEP_STATE_CLASS = {
  finished: TIMELINE_FINISHED_DOT_CLASS_NAME,
  active: TIMELINE_ACTIVE_DOT_CLASS_NAME,
  pending: TIMELINE_PENDING_DOT_CLASS_NAME,
};

const InvoiceTrackingTimeline = ({ steps }) => (
  <Timeline className={TIMELINE_CLASS_NAME}>
    {steps.map((step, index) => {
      const isLast = index === steps.length - 1;
      return (
        <TimelineItem key={step.key} className={STEP_STATE_CLASS[step.state]}>
          <TimelineSeparator>
            <TimelineDot>
              {step.state === 'finished' && <CheckIcon sx={{ fontSize: 16 }} />}
            </TimelineDot>
            {!isLast && <TimelineConnector />}
          </TimelineSeparator>
          <TimelineContent sx={{ pb: isLast ? 0 : 2 }}>
            <Typography
              className={TIMELINE_LABEL_CLASS_NAME}
              variant="small_2"
              fontWeight={700}
            >
              {step.label}
            </Typography>
            {step.datetime && (
              <Typography
                className={TIMELINE_CAPTION_CLASS_NAME}
                variant="small_1"
                display="block"
              >
                {step.datetime}
              </Typography>
            )}
            {step.extra && (
              <Typography
                className={TIMELINE_CAPTION_CLASS_NAME}
                variant="small_1"
                display="block"
              >
                {step.extra}
              </Typography>
            )}
            {(step.bullets || []).map((bullet) => (bullet.tone === 'error' ? (
              <Typography
                key={bullet.text}
                variant="small_1"
                color="error.main"
                display="block"
                sx={{ pl: 1 }}
              >
                {`• ${bullet.text}`}
              </Typography>
            ) : (
              <Typography
                key={bullet.text}
                className={TIMELINE_CAPTION_CLASS_NAME}
                variant="small_1"
                display="block"
                sx={{ pl: 1 }}
              >
                {`• ${bullet.text}`}
              </Typography>
            )))}
          </TimelineContent>
        </TimelineItem>
      );
    })}
  </Timeline>
);

InvoiceTrackingTimeline.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      state: PropTypes.oneOf(['finished', 'active', 'pending']).isRequired,
      datetime: PropTypes.string,
      extra: PropTypes.string,
      bullets: PropTypes.arrayOf(
        PropTypes.shape({ text: PropTypes.string, tone: PropTypes.string }),
      ),
    }),
  ).isRequired,
};

export default InvoiceTrackingTimeline;
